__webpack_require__.p = "/apps/memories/js/";